import React from "react";
import styles from "./footer.module.css";

import logoFooter from "../../assets/images/logo cairo capital-01 copy.png";
const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.logoSection}>
          <img src={logoFooter} alt="Cairo Capital" className={styles.logo} />
        </div>

        <div className={styles.contactSection}>
          <h4>Contact Us</h4>
          <p>7 Lazoghli street, Garden City, Cairo, Egypt</p>
          <p>+20 227924281/2/3</p>
          <p>info@cairocapitalgroup.com</p>
        </div>
      </div>

      {/* Bottom Text */}
      <div className={styles.bottomText}>
        © 2025 Cairo Capital. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
